import { ApiRoute, Route } from 'config';
import { put } from 'utils/network';
import useNavigateHook from 'hooks/useNavigateHook';

import { useCart } from 'contexts/Cart';
import HeapAnalytics from 'services/HeapAnalytics';

import IApiResponse from 'models/IApiResponse';

type SetSaving = (isSaving: boolean) => void;

function useSaveCart(setSaving: SetSaving = () => null): typeof handleSaveCart {
  const { cart, dispatch } = useCart();
  const { id: cartId } = cart;
  const useNavigate = useNavigateHook();
  const navigate = useNavigate();

  const handleSaveCart = async (
    redirectionUrl?: string,
    onError?: () => void,
  ) => {
    setSaving(true);

    HeapAnalytics.trackCartUpdated(
      cart.initialMenuItems,
      cart.menu_items,
    );

    const response = await put<IApiResponse>(
      `${ApiRoute.CARTS}/${cartId}`,
      {
        cart: {
          cart_items: cart
            .selectedItems
            .map(({ sku, quantity }) => ({ sku_id: sku.id, quantity })),
        },
      },
    );

    if (response.status === 422) {
      const invalidSkuIds = response?.parsedBody?.invalid_resources;

      if (invalidSkuIds) {
        dispatch({
          type: 'setMenuItemQuantities',
          skuIds: cart.initialMenuItems.filter(
            (initial) => invalidSkuIds.some(
              (invalid) => initial.skuId === invalid.id,
            ),
          ),
          setMaxQty: true,
        });
      }

      if (onError) onError();

      if (response?.parsedBody?.code === '3031') {
        setTimeout(() => navigate(Route.UPCOMING_MENUS), 2000);
      }
    } else if (redirectionUrl) {
      navigate(redirectionUrl);
    }

    setSaving(false);
  };

  return handleSaveCart;
}

export default useSaveCart;
